import { createAction } from '@reduxjs/toolkit';
import { AxiosResponseStatus } from './types';
import { JobLog } from '../../models/jobLog';

const tryFetchLogInfoStart = createAction('LOGS.TRY_FETCH_INFO.START');

const tryFetchLogInfoSuccess = createAction<JobLog>('LOGS.TRY_FETCH_INFO.SUCCESS');

const tryFetchLogInfoFailure = createAction<AxiosResponseStatus>('LOGS.TRY_FETCH_INFO.FAILURE');

export const logInfoActions = {
  tryFetchLogInfoStart,
  tryFetchLogInfoSuccess,
  tryFetchLogInfoFailure,
};
